import { initNamespaceStorage } from 'js-storage';

export default function myDmsCleanupSessionStorage () {
	const dmsAmbulanceStorage = initNamespaceStorage('dms-ambulance').sessionStorage;
	dmsAmbulanceStorage.removeAll();
}
